import { Text, Code, Label, FormattedDateTime } from '@customerio/pluma-components/react';
import type { AnonymousInAppState, SearchResult } from '@/services/auth/types';
import { MetadataRow } from './metadata-row';

type Props = { result: Extract<SearchResult, { kind: 'anonymous_in_app' }> };

// Partial so an unrecognised state (e.g. a future backend value) falls through to no badge
// rather than crashing — the description and timestamps still render.
const STATE_CONFIG: Partial<Record<AnonymousInAppState, { label: string; color: 'green' | 'grey' | 'yellow' }>> = {
  drafted: { label: 'Draft', color: 'grey' },
  scheduled: { label: 'Scheduled', color: 'grey' },
  starting: { label: 'Starting', color: 'green' },
  running: { label: 'Running', color: 'green' },
  stopping: { label: 'Stopping', color: 'yellow' },
  expired: { label: 'Expired', color: 'grey' },
  stopped: { label: 'Stopped', color: 'grey' },
};

export function AnonymousInAppPreview({ result }: Props) {
  const { state } = result.other;
  const stateConfig = state != null ? STATE_CONFIG[state] : undefined;

  return (
    <>
      <MetadataRow label="ID">
        <Code size="xs">{result.other.id}</Code>
      </MetadataRow>
      {stateConfig != null ? (
        <MetadataRow label="Status">
          <Label color={stateConfig.color}>{stateConfig.label}</Label>
        </MetadataRow>
      ) : null}
      <MetadataRow label="Created">
        <Text size="xs">
          <FormattedDateTime className="fs-mask" date={result.other.created_at} format="medium" />
        </Text>
      </MetadataRow>
      <MetadataRow label="Updated">
        <Text size="xs">
          <FormattedDateTime className="fs-mask" date={result.other.updated_at} format="medium" />
        </Text>
      </MetadataRow>
    </>
  );
}
